/**
 * Shared row-identity helpers for the Screener & Watchlist result tables and
 * their elasticity heatmap views.
 *
 * Why this exists: the favorites / removed-rows feature keys each contract by a
 * `Ticker|Option Type|Strike|Expiration` string, and the "favorites float to
 * top" sort comparator runs on EVERY render against EVERY row. If a single
 * null/undefined/malformed entry slips into the results array (stale localStorage
 * payload, partial refresh, an older cached shape), dereferencing it inside the
 * comparator/filter/render throws a render-phase exception that the surrounding
 * ErrorBoundary turns into "the table errored out". Centralizing the key builder
 * and an array-compaction helper keeps every consumer null-safe and identical.
 */

// Null-safe identity key. Matches the historical "|"-joined format exactly so
// existing in-memory favorite/removed Sets keep matching. A missing row yields
// '' (never throws); a row missing fields yields a defined "undefined|..." string.
export const getRowKey = (row) =>
  row ? `${row['Ticker']}|${row['Option Type']}|${row['Strike']}|${row['Expiration']}` : '';

// Drop null / undefined / non-object entries before any sort/filter/render so a
// bad row can never reach a comparator, predicate, or JSX dereference.
export const compactRows = (rows) =>
  Array.isArray(rows) ? rows.filter((r) => r && typeof r === 'object') : [];
